import React from 'react';
import { render } from 'react-dom';
import{ BrowserRouter, Match, Miss } from 'react-router';

import './css/style.css';

import StorePicker from './components/StorePicker';
import App from './components/App';
import NotFound from './components/NotFound';

function Root() {
	return (
		<BrowserRouter>
		<div>
			<Match exactly pattern="/catch-of-the-day" component={StorePicker}/>
			<Match exactly pattern="/store/:storeId" component={App}/>
			<Miss component={NotFound} />
		</div>
		</BrowserRouter>
	)
}


render( <Root/>, document.getElementById('main') );



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/